import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FeedsQueryKeys } from './feeds.keys';
import { PostInterface } from '../../app-schemas/posts/post.schema';
import apiClient from '../ApiClient';

const voteByIndex = async (postId: number, index: number) => {
  return await apiClient.post(`polls/${postId}/vote`, { option_index: index });
};

export const useVoteByIndex = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ postId, index }: { postId: number; index: number }) =>
      voteByIndex(postId, index),

    onMutate: async ({ postId, index }: { postId: number; index: number }) => {
      await queryClient.cancelQueries({ queryKey: FeedsQueryKeys.all });

      const previousData: any = queryClient.getQueryData(FeedsQueryKeys.all);
      if (!previousData) return { previousData };

      const updatedPages = previousData?.pages.map((page: any) => {
        const updatedPosts = page?.data.map((post: PostInterface) => {
          if (post.post_id !== postId || !post.poll_results) return post;

          const alreadyVotedIndex = post.poll_results.findIndex(
            (opt) => opt.has_voted
          );
          const isSameVote = alreadyVotedIndex === index;

          const updatedPollResults = post.poll_results.map((opt, i) => {
            if (i === alreadyVotedIndex && !isSameVote)
              return { ...opt, votes: opt.votes - 1, has_voted: false };
            if (i === index && !isSameVote)
              return { ...opt, votes: opt.votes + 1, has_voted: true };
            return opt;
          });

          return { ...post, poll_results: updatedPollResults };
        });

        return { ...page, data: updatedPosts };
      });

      queryClient.setQueryData(FeedsQueryKeys.all, {
        ...previousData,
        pages: updatedPages,
      });

      return { previousData };
    },

    onError: (_error, _vars, context: any) => {
      if (context?.previousData) {
        queryClient.setQueryData(FeedsQueryKeys.all, context.previousData);
      }
    },
  });
};